import { useTranslation } from "react-i18next";
import React, { Fragment, useEffect, useRef } from "react";
import { Grid, Card, Box, Typography, Hidden, TextField } from "@mui/material";
import { setColor2, roundTo } from "../../functions/default";
import Reisekostenabrechnung from "../FormularPages/Reisekostenabrechnung";
import Belegerkennung from "../FormularPages/Belegerekennung";
import FormularFeld from "./FormularFeld";
import DatumsGruppe from "../FormularPages/DatumsGruppe";
import BelegEingabe from "../FormularPages/BelegEingabe/BelegEingabe";
import Bankverbindung from "../FormularPages/BelegEingabe/Bankverbindung";
import Saldenauszahlung from "../FormularPages/BelegEingabe/Saldenauszahlung";

function Formular(props) {
  //Standardvariablen/konstanten
  const {
    formular,
    formularkey,
    liste,
    felder,
    stammfelder,
    hper,
    felderError,
    ChangeFelder,
    uebergaben,
    lock,
    files,
    ChangeFiles,
    DateiLaden,
    bemerkung,
    ZSpeichern,
    dbliste,
    accessToken,
    client,
    program,
    genehmigen,
    setSaldenauszahlungDisableButtons,
    ankeyRes,
    bearbeiten,
    selectedKonto,
    setSelectedKonto,
  } = props;
  const { t } = useTranslation();
  //Arbeitsvariablen/konstanten
  const mexp = require("math-expression-evaluator");
  const recfelder = useRef({});
  const grpfelder = useRef({});
  const samegrp = useRef(false);
  const changefeld = useRef("");
  const title = felder && felder[formular] && felder[formular][formular] && felder[formular][formular].name;
  //Standardfunktionen
  useEffect(() => {
    if (!felder[formular]) return;
    var rfelder = {};
    var array = Object.keys(felder[formular]);
    var feld = null;
    var inhalt = null;
    array &&
      array
        .filter((fitem) => {
          if (fitem.substr(0, 1) !== "R") return false;
          return true;
        })
        .forEach((item) => {
          feld = felder[formular][item];

          if (feld.typ === "01") {
            inhalt = feld.inhalt.replace(/;/g, ",").split(",");
            inhalt
              .filter((fkey) => {
                if (!fkey) return false;
                return true;
              })
              .forEach((key) => {
                if (!rfelder[key]) {
                  rfelder[key] = item + ";";
                } else {
                  rfelder[key] += item + ";";
                }
              });
          }
          if (feld.typ === "02") {
            inhalt = SplitRfeld(feld.inhalt).split(";");
            inhalt
              .filter((fkey) => {
                if (!fkey) return false;
                return true;
              })
              .forEach((key) => {
                if (!rfelder[key]) {
                  rfelder[key] = item + ";";
                } else {
                  rfelder[key] += item + ";";
                }
              });
          }
          recfelder.current = rfelder;

          if (feld.typ === "03") {
            inhalt = SplitRfeld(feld.inhalt).split(";");
            inhalt
              .filter((fkey) => {
                if (!fkey) return false;
                return true;
              })
              .forEach((key) => {
                if (!rfelder[key]) {
                  rfelder[key] = item + ";";
                } else {
                  rfelder[key] += item + ";";
                }
              });
          }
          recfelder.current = rfelder;
          if (feld.typ === "04") {
            inhalt = SplitRfeld(feld.inhalt).split(";");
            inhalt
              .filter((fkey) => {
                if (!fkey) return false;
                return true;
              })
              .forEach((key) => {
                if (!rfelder[key]) {
                  rfelder[key] = item + ";";
                } else {
                  rfelder[key] += item + ";";
                }
              });
          }
          recfelder.current = rfelder;
          if (feld.typ === "05") {
            inhalt = SplitRfeld(feld.inhalt).split(";");
            inhalt
              .filter((fkey) => {
                if (!fkey) return false;
                return true;
              })
              .forEach((key) => {
                if (!rfelder[key]) {
                  rfelder[key] = item + ";";
                } else {
                  rfelder[key] += item + ";";
                }
              });
          }
          recfelder.current = rfelder;
          if (feld.typ === "06") {
            inhalt = SplitRfeld(feld.inhalt).split(";");
            inhalt
              .filter((fkey) => {
                if (!fkey) return false;
                return true;
              })
              .forEach((key) => {
                if (!rfelder[key]) {
                  rfelder[key] = item + ";";
                } else {
                  rfelder[key] += item + ";";
                }
              });
          }
          recfelder.current = rfelder;
          if (feld.typ === "07") {
            inhalt = SplitRfeld(feld.inhalt).split(";");
            inhalt
              .filter((fkey) => {
                if (!fkey) return false;
                return true;
              })
              .forEach((key) => {
                if (!rfelder[key]) {
                  rfelder[key] = item + ";";
                } else {
                  rfelder[key] += item + ";";
                }
              });
          }
          recfelder.current = rfelder;
        });

    // eslint-disable-next-line
  }, [formular, liste, felder, stammfelder, hper, felderError, ChangeFelder]);
  function splitArray(arr) {
    const result = [];
    let currentArray = [];

    for (const item of arr) {
      if (item.startsWith("I")) {
        if (currentArray.length > 0) {
          result.push(currentArray);
          currentArray = [];
        }
      } else {
        currentArray.push(item);
      }
    }

    if (currentArray.length > 0) {
      result.push(currentArray);
    }

    return result;
  }

  function SplitRfeld(string) {
    var value = string;
    var pos = value.indexOf("|");
    if (pos !== -1) {
      value = value.substr(pos + 1);
      pos = value.indexOf("|");
      value = value.substr(0, 4) + ";" + SplitRfeld(value.substr(pos + 1));
    } else {
      value = "";
    }
    return value;
  }

  //Arbeitsfunktionen

  function WertChange(feldkey, value, indexstring, gruppe) {
    changefeld.current = feldkey;
    if (!indexstring) {
      felder[formular][feldkey] = value;
      if (recfelder.current[feldkey]) {
        Summenfelder(recfelder.current[feldkey].split(";"), indexstring);
        ChangeFelder(bonus, "", felder);
      }
    } else {
      if (!felder[formular][feldkey].antwort) felder[formular][feldkey].antwort = {};
      felder[formular][feldkey].antwort[indexstring] = value;
      if (recfelder.current[feldkey]) {
        Summenfelder(recfelder.current[feldkey].split(";"), indexstring);
        ChangeFelder(bonus, "", felder);
      }
      if (gruppe) {
        pruefeAntworten(felder[formular][gruppe].inhalt.split(";"));

        ChangeFelder(bonus, "", felder);
      }
    }
    var bonus = "";
    if (felder && felder[formular] && felder[formular][feldkey] && felder[formular][feldkey].art === "E" && felder[formular][feldkey].typ === "09")
      bonus = "upload";
    // ChangeFelder(bonus,"",felder)
  }

  function Summenfelder(inhalt, indexstring) {
    var art = "";
    var tmpantwort;
    inhalt
      .filter((fitem) => {
        if (!fitem) return false;
        return true;
      })
      .forEach((item) => {
        art =
          felder[formular][item].typ === "01"
            ? "S"
            : felder[formular][item].typ === "02" || felder[formular][item].typ === "07"
              ? "R"
              : felder[formular][item].typ === "03"
                ? "DR"
                : felder[formular][item].typ === "04"
                  ? "SP"
                  : "BR";
        if (felder[formular][item]) {
          if (!grpfelder.current[item]) {
            felder[formular][item].antwort = Summe(felder[formular][item].inhalt, art, undefined, undefined, felder[formular][item].negativ);
          } else {
            if (!felder[formular][item].antwort) {
              felder[formular][item].antwort = {};
            }
            /*samegrp.current=false
          tmpantwort=Summe(felder[formular][item].inhalt,art,grpfelder.current[item],Number(indexstring))
          if (samegrp.current===true){
            felder[formular][item].antwort[indexstring]=tmpantwort
          } else {
            var anzahl=Number(felder[formular][grpfelder.current[item]].logik)A
            for (let i=1; i<=anzahl;i++){
              felder[formular][item].antwort[i.toString()]=tmpantwort
            }
          }*/

            var anzahl = Number(felder[formular][grpfelder.current[item]].logik);

            for (let i = 1; i <= anzahl; i++) {
              // { console.log(Summe(felder[formular][item].inhalt, art, grpfelder.current[item], i, felder[formular][item].negativ)) }
              // console.log(Summe(felder[formular][item].inhalt, art, grpfelder.current[item], i, felder[formular][item].negativ))

              felder[formular][item].antwort[i.toString()] = Summe(
                felder[formular][item].inhalt,
                art,
                grpfelder.current[item],
                i,
                felder[formular][item].negativ,
              );
            }
          }
        }
        if (recfelder.current[item]) {
          Summenfelder(recfelder.current[item].split(";"), indexstring);
        }
      });
  }

  function Summenfeld(inhalt, gruppe, ind) {
    var tmpinhalt = inhalt.split(";");
    var ergebnis = 0;
    tmpinhalt.forEach((item) => {
      var items = item.split(",");
      if (!items[0]) return;
      if (!felder[formular][items[0]]) return;
      var tmpantwort = felder[formular][items[0]].antwort;
      if (Object.prototype.toString.call(tmpantwort) === "[object Object]") {
        Object.entries(tmpantwort)
          .filter((fitem) => {
            if (!gruppe) return true;
            if (!(felder[formular][gruppe].inhalt + ";").includes(items[0] + ";")) return true;
            samegrp.current = true;
            // eslint-disable-next-line
            var [fkey, fvalue] = fitem;
            // eslint-disable-next-line
            if (fkey == ind) return true;
            return false;
          })
          .forEach((entry) => {
            var [key, value] = entry;
            if (items[1]) {
              if (felder[formular][items[1]].antwort) {
                if (Object.prototype.toString.call(felder[formular][items[1]].antwort) === "[object Object]") {
                  if (felder[formular][items[1]].antwort[key]) {
                    ergebnis += Number(value ? value : 0);
                  }
                } else {
                  ergebnis += Number(value ? value : 0);
                }
              }
            } else {
              ergebnis += Number(value ? value : 0);
            }
          });
      } else {
        if (items[1]) {
          if (felder[formular][items[1]].antwort) {
            ergebnis += Number(tmpantwort ? tmpantwort : 0);
          }
        } else {
          ergebnis += Number(tmpantwort ? tmpantwort : 0);
        }
      }
    });
    return roundTo(ergebnis, 2);
  }
  function DateiSubFelder(tmpinhalt, gruppe, ind) {
    var inhalt = tmpinhalt;
    try {
      var pos = inhalt.indexOf("|");
    } catch (error) {
      // console.log(inhalt)
      return inhalt;
    }
    var pos = inhalt.indexOf("|");
    if (pos !== -1) {
      var tmpstring = inhalt.substr(pos);
      tmpstring = tmpstring.substr(0, tmpstring.indexOf("|", 1) + 1);
      var indnumber = "";
      if (tmpstring.substr(5, 1) === "#") {
        var tmpantwort = felder[formular][tmpstring.substr(1, 4)].antwort;
        indnumber = tmpstring.substr(6, tmpstring.length - 7);
      } else {
        var tmpantwort = felder[formular][tmpstring.substr(1, 4)].antwort;
        // if (felder[formular][tmpstring.substr(1, 4)].art === "E" && felder[formular][tmpstring.substr(1, 4)].typ === "14") {
        //   //Bei dem Feld handelt es sich um das Dateiupload mit auslesen Feld, in dem Fall antwort komplett zurückgeben (PE)
        //   return (tmpantwort)
        // }
      }
      if (tmpantwort) {
        if (Object.prototype.toString.call(tmpantwort) === "[object Object]") {
          var ergebnis = 0;

          Object.entries(tmpantwort)
            .filter((fitem) => {
              var [fkey, fvalue] = fitem;
              // eslint-disable-next-line
              if (indnumber !== "" && Number(indnumber) !== Number(fkey) + 1) return false;
              if (!gruppe) return true;
              if (!(felder[formular][gruppe].inhalt + ";").includes([tmpstring.substr(1, 4)] + ";")) return true;
              samegrp.current = true;
              // eslint-disable-next-line
              if (fkey == ind) return true;
              return false;
            })
            .forEach((entry) => {
              var [, value] = entry;
              if (felder[formular][tmpstring.substr(1, 4)].art === "E" && felder[formular][tmpstring.substr(1, 4)].typ === "14") {
                //Bei dem Feld handelt es sich um das Dateiupload mit auslesen Feld, in dem Fall antwort komplett zurückgeben (PE)
                ergebnis = value;
              } else {
                if (value && value.toString().includes("|")) {
                  value = value.substr(0, value.indexOf("|", 1));
                }
                if ((value && value.toString().includes("T") && value.toString().includes(":")) || value?.toString().includes("/")) {
                  //Hier können wir mit einem Datum rechnen (PE)
                  ergebnis = value;
                } else {
                  ergebnis = roundTo(ergebnis + Number(value ? value : "0"), 2);
                }
              }
            });
          if (felder[formular][tmpstring.substr(1, 4)].art === "E" && felder[formular][tmpstring.substr(1, 4)].typ === "14") {
            //Bei dem Feld handelt es sich um das Dateiupload mit auslesen Feld, in dem Fall antwort komplett zurückgeben (PE)
            inhalt = ergebnis;
          } else {
            inhalt = inhalt.replace(tmpstring, ergebnis);
          }
        } else {
          if (tmpantwort && tmpantwort.toString().includes("|")) {
            tmpantwort = tmpantwort.substr(0, tmpantwort.indexOf("|", 1));
          }
          inhalt = inhalt.replace(tmpstring, tmpantwort);
        }
      } else {
        inhalt = inhalt.replace(tmpstring, "0");
      }
      return DateiSubFelder(inhalt, gruppe, ind);
    }
    return inhalt;
  }
  function SubFelder(tmpinhalt, gruppe, ind) {
    // if (tmpinhalt.includes("P001")){console.log(tmpinhalt)}
    var inhalt = tmpinhalt;
    var pos = inhalt.indexOf("|");
    // if (tmpinhalt.includes("P001")){console.log(pos)}

    if (pos !== -1) {
      var tmpstring = inhalt.substr(pos);

      if (tmpstring.includes("P") && tmpstring.includes("[") && tmpstring.includes("]")) {
        var indexEnde = tmpstring.indexOf("]");
        var feld = tmpstring.substr(1, 4);
        var tmpantwort = felder[formular][feld]?.[tmpstring.substring(tmpstring.indexOf("[") + 1, indexEnde)];
      } else {
        tmpstring = tmpstring.substr(0, tmpstring.indexOf("|", 1) + 1);
        var indnumber = "";
        if (tmpstring.substr(5, 1) === "#") {
          var tmpantwort = felder[formular][tmpstring.substr(1, 4)]?.antwort;
          indnumber = tmpstring.substr(6, tmpstring.length - 7);
        } else {
          var tmpantwort = felder[formular][tmpstring.substr(1, 4)]?.antwort;
          if (felder[formular][tmpstring.substr(1, 4)]?.art === "E" && felder[formular][tmpstring.substr(1, 4)]?.typ === "14") {
            //Bei dem Feld handelt es sich um das Dateiupload mit auslesen Feld, in dem Fall antwort komplett zurückgeben (PE)
            return tmpantwort;
          }
        }
      }
      if (tmpantwort) {
        if (Object.prototype.toString.call(tmpantwort) === "[object Object]") {
          var ergebnis = 0;
          Object.entries(tmpantwort)
            .filter((fitem) => {
              var [fkey, fvalue] = fitem;
              // eslint-disable-next-line
              if (indnumber !== "" && Number(indnumber) !== Number(fkey) + 1) return false;
              if (!gruppe) return true;
              if (!(felder[formular][gruppe].inhalt + ";").includes([tmpstring.substr(1, 4)] + ";")) return true;
              samegrp.current = true;
              // eslint-disable-next-line
              if (fkey == ind) return true;
              return false;
            })
            .forEach((entry) => {
              var [, value] = entry;
              if (value && value.toString().includes("|")) {
                value = value.substr(0, value.indexOf("|", 1));
              }
              if ((value && value.toString().includes("T") && value.toString().includes(":")) || value?.toString().includes("/")) {
                //Hier können wir mit einem Datum rechnen (PE)
                ergebnis = value;
              } else {
                ergebnis = roundTo(ergebnis + Number(value ? value : "0"), 2);
              }
            });
          inhalt = inhalt.replace(tmpstring, ergebnis);
        } else {
          if (tmpantwort && tmpantwort.toString().includes("|")) {
            tmpantwort = tmpantwort.substr(0, tmpantwort.indexOf("|", 1));
          }
          inhalt = inhalt.replace(tmpstring, tmpantwort);
        }
      } else {
        inhalt = inhalt.replace(tmpstring, "0");
      }
      return SubFelder(inhalt, gruppe, ind);
    }
    return inhalt;
  }

  function Rechenfeld(tmpinhalt, gruppe, ind) {
    var inhalt = SubFelder(tmpinhalt, gruppe, ind);

    var ergebnis = 0;
    if (program === "FORGEN") {
      inhalt = inhalt.replace(/;/g, "");
    }

    try {
      ergebnis = mexp.eval(inhalt);
    } catch (e) {
      return "NaN";
    }
    ergebnis = mexp.eval(inhalt);

    return roundTo(ergebnis, 2);
  }
  function BelegRechenFeld(tmpinhalt, gruppe, ind) {
    let zwisInhalt = tmpinhalt.split("[");
    var inhalt = DateiSubFelder(zwisInhalt[0], gruppe, ind);

    zwisInhalt[1] = zwisInhalt[1]?.replace("]", "");
    if (inhalt[zwisInhalt[1]] === undefined) {
      return 0;
    }
    return inhalt[zwisInhalt[1]];
  }
  function DatumsRechenFeld(tmpinhalt, gruppe, ind) {
    var inhalt = SubFelder(tmpinhalt, gruppe, ind);
    var ergebnis = 0;
    var dates = inhalt.split("BIS");
    if (dates[0] === "0" || dates[1] === "0" || dates[0] === "NaN") {
      return 0;
    }
    // if (dates[0])
    return getDaysBetweenDates(dates[0]?.replace("T", " "), dates[1]?.replace("T", " "));
  }
  function SpesenRechenFeld(tmpinhalt, gruppe, ind) {
    var inhalt = SubFelder(tmpinhalt, gruppe, ind);

    // var inhalt = SubFelder(tmpinhalt, gruppe, ind);
    // if (inhalt.includes("-ABZUG")) {
    //   inhalt = inhalt.replace("-ABZUG", "");
    //   var teile = inhalt.split(")");
    //   teile[0] = teile[0].replace("(", "");
    //   var zwischenErgebis = 0;
    //   teile[0].split("+")?.map((x) => {
    //     var gleichung = x.replace(",", ".");
    //     zwischenErgebis += parseInt(gleichung.split("*")[0]) * parseFloat(gleichung.split("*")[1]);
    //   });
    //   var spesenSaetze = {};
    //   spesenSaetze["VP8"] = teile[1].split("/")[0];
    //   spesenSaetze["VP24"] = teile[1].split("/")[1];
    //   var ergebnis = parseFloat(parseInt(spesenSaetze["VP24"]) * zwischenErgebis).toFixed(2);
    // } else {
    //   var teile = inhalt.split("*");

    //   if (teile[0] === "0") {
    //     return 0;
    //   }
    //   var spesenSaetze = {};
    //   spesenSaetze["VP8"] = teile[1].split("/")[0];
    //   spesenSaetze["VP24"] = teile[1].split("/")[1];
    //   var ergebnis = (parseInt(teile[0].split(".")[0]) - 2) * spesenSaetze["VP24"] + spesenSaetze["VP8"] * 2;
    // }
    return inhalt;
  }
  function getDaysBetweenDates(d0, d1) {
    var msPerDay = 8.64e8;
    var x0 = new Date(d0);
    var x1 = new Date(d1);
    return (((x1 - x0) / msPerDay) * 1000) / 100;
  }
  function Summe(inhalt, art, gruppe, ind, negativ) {
    if (art === "S") {
      if (negativ === "1") {
        return Math.max(Summenfeld(inhalt, gruppe, ind), 0);
      } else {
        return Summenfeld(inhalt, gruppe, ind);
      }
    }
    if (art === "R") {
      if (negativ === "1") {
        return Math.max(Rechenfeld(inhalt, gruppe, ind), 0);
      } else {
        return Rechenfeld(inhalt, gruppe, ind);
      }
    }
    if (art === "DR") {
      return DatumsRechenFeld(inhalt, gruppe, ind);
    }
    if (art === "SP") {
      return SpesenRechenFeld(inhalt, gruppe, ind);
    }
    if (art === "BR") {
      return BelegRechenFeld(inhalt, gruppe, ind);
    }
  }

  function pruefeAntworten(tmparray, norender) {
    var tmpantwort = {};
    var vglkeys = [];
    var rerender = false;
    tmparray.forEach((id) => {
      if (!felder[formular][id].antwort) return;
      //if (felder[formular][id].art==="R") return
      tmpantwort[id] = {};
      const keys = Object.keys(felder[formular][id].antwort);
      keys.forEach((key) => {
        if (felder[formular][id].antwort[key] === "") return;
        // eslint-disable-next-line
        if (felder[formular][id].art === "R" && felder[formular][id].antwort[key] == 0) return;
        if (felder[formular][id].art === "E" && felder[formular][id].typ === "11" && felder[formular][id].antwort[key] == 0) return;

        if (!vglkeys.some((value) => value === key)) {
          vglkeys.push(key);
        }
      });
    });
    var tmpkey = 0;
    vglkeys.sort((a, b) => a - b);
    vglkeys.forEach((key) => {
      if (key - tmpkey > 1) {
        tmpkey++;
        tmparray.forEach((id) => {
          //if (felder[formular][id].art==="R"&&felder[formular][id].antwort[key]==0) return
          //if (felder[formular][id].art==="R") return
          //if (felder[formular][id].art==="R"&&felder[formular][id].antwort[key]==0) return
          if (!felder[formular][id].antwort) return;
          if (!felder[formular][id].antwort[key]) return;
          tmpantwort[id][tmpkey] = felder[formular][id].antwort[key];
          rerender = true;
        });
        return;
      }
      tmparray.forEach((id) => {
        //if (felder[formular][id].art==="R"&&felder[formular][id].antwort[key]==0) return
        //if (felder[formular][id].art==="R"&&felder[formular][id].antwort[key]==0) return
        if (!felder[formular][id].antwort) return;
        if (!felder[formular][id].antwort[key]) return;
        tmpantwort[id][key] = felder[formular][id].antwort[key];
      });
      tmpkey = Number(key);
    });
    if (rerender) {
      var tmpa = { ...felder };

      Object.keys(tmpantwort).forEach((item) => {
        tmpa[formular][item].antwort = tmpantwort[item];
        //ChangeFelder(item,tmpantwort[item])
      });
      //setWhyobject(tmpa)
      ChangeFelder("", "", tmpa);
    }
    return vglkeys.length;
  }
  function renderPFeld(item) {
    var italic = false;
    var bold = false;
    if (item.extra === "REISEKOSTEN") {
      return (
        <Reisekostenabrechnung
          program={program}
          accessToken={accessToken}
          key={felder[formular][item.key]}
          lock={lock}
          element={felder[formular][item.key]}
          onChange={WertChange}
          client={client}
        />
      );
    }
    if (item.extra === "BELEGE") {
      return (
        <Belegerkennung
          // mehrereBelegeErlauben={liste.find((item) => item.substr(0, 1) === "P" && felder[formular][item]?.extra === "REISEKOSTEN") ? true : false}
          mehrereBelegeErlauben={true}
          ChangeFiles={ChangeFiles}
          formular={formular}
          files={files}
          program={program}
          accessToken={accessToken}
          key={felder[formular][item.key]}
          lock={lock}
          element={felder[formular][item.key]}
          onChange={WertChange}
          client={client}
        />
      );
    }
    if (item.extra === "BELEGE_2") {
      return (
        <BelegEingabe
          mehrereBelegeErlauben={liste.find((item) => item.substr(0, 1) === "P" && felder[formular][item]?.extra === "REISEKOSTEN") ? true : false}
          ChangeFiles={ChangeFiles}
          files={files}
          program={program}
          formular={formular}
          accessToken={accessToken}
          key={felder[formular][item.key]}
          lock={lock}
          element={felder[formular][item.key]}
          onChange={WertChange}
          client={client}
        />
      );
    }
    if (item.extra === "BANKVERBINDUNG") {
      return (
        <Bankverbindung
          ChangeFiles={ChangeFiles}
          files={files}
          program={program}
          formular={formular}
          accessToken={accessToken}
          formularkey={formularkey}
          key={felder[formular][item.key]}
          lock={lock}
          element={felder[formular][item.key]}
          onChange={WertChange}
          client={client}
        />
      );
    }
    if (item.extra === "SALDENAUSZAHLUNG") {
      return (
        <Saldenauszahlung
          felder={felder}
          mehrereBelegeErlauben={liste.find((item) => item.substr(0, 1) === "P" && felder[formular][item]?.extra === "REISEKOSTEN") ? true : false}
          ChangeFiles={ChangeFiles}
          files={files}
          program={program}
          formular={formular}
          accessToken={accessToken}
          formularkey={formularkey}
          key={felder[formular][item.key]}
          lock={lock}
          element={felder[formular][item.key]}
          onChange={WertChange}
          client={client}
          hper={hper}
          genehmigen={genehmigen}
          setSaldenauszahlungDisableButtons={setSaldenauszahlungDisableButtons}
          ankeyRes={ankeyRes}
          bearbeiten={bearbeiten}
        />
      );
    }
  }

  function renderVFeld(item) {
    return (
      <DatumsGruppe
        mehrereBelegeErlauben={liste.find((item) => item.substr(0, 1) === "P" && felder[formular][item]?.extra === "REISEKOSTEN") ? true : false}
        ChangeFiles={ChangeFiles}
        files={files}
        program={program}
        pruefeAntworten={pruefeAntworten}
        renderGruppe={renderGruppe}
        felder={felder}
        ZSpeichern={ZSpeichern}
        forLoop={forLoop}
        forLoopMobil={forLoopMobil}
        felderError={felderError}
        formular={formular}
        DateiLaden={DateiLaden}
        accessToken={accessToken}
        key={felder[formular][item.key]}
        lock={lock}
        Summe={Summe}
        uebergaben={uebergaben}
        element={felder[formular][item.key]}
        onChange={WertChange}
        client={client}
      />
    );
  }
  //Renderfunktionen
  function renderGruppe(item) {
    var italic = false;
    var bold = false;
    const tmparray = item.inhalt.split(";");

    var zeilen = pruefeAntworten(tmparray);
    var breite = 12 / tmparray.length;

    return (
      <Fragment>
        <Hidden mdDown>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              {Number(item.logik) > 1 && <Grid item xs={1}></Grid>}
              <Grid item xs={11}>
                <Grid container spacing={1}>
                  {tmparray.map((id, index) => {
                    italic = false;
                    bold = false;
                    if (felder[formular][id].art === "R" && felder[formular][id].typ === "07") {
                      return;
                    }
                    if (felder[formular][id].format && (felder[formular][id].format === "03" || felder[formular][id].format === "04")) italic = true;
                    if (felder[formular][id].format && (felder[formular][id].format === "02" || felder[formular][id].format === "04")) bold = true;
                    return (
                      <Fragment>
                        <Grid item xs={12} md={breite <= 2.4 ? true : breite} align="left">
                          {felderError.some((i) => i.substr(0, 4) === id) && (
                            <Typography
                              fullWidth
                              style={
                                bold && italic
                                  ? { fontStyle: "italic", fontWeight: "bold", color: setColor2("255100100", 1) }
                                  : bold
                                    ? { fontWeight: "bold", color: setColor2("255100100", 1) }
                                    : italic
                                      ? { fontStyle: "italic", color: setColor2("255100100", 1) }
                                      : { color: setColor2("255100100", 1) }
                              }
                            >
                              {felder[formular][id].label === "1" ? "" : felder[formular][id].name}
                            </Typography>
                          )}
                          {!felderError.some((i) => i.substr(0, 4) === id) && (
                            <Typography
                              fullWidth
                              style={
                                bold && italic
                                  ? { fontStyle: "italic", fontWeight: "bold" }
                                  : bold
                                    ? { fontWeight: "bold" }
                                    : italic
                                      ? { fontStyle: "italic" }
                                      : {}
                              }
                            >
                              {felder[formular][id].label === "1" ? "" : felder[formular][id].name}
                            </Typography>
                          )}
                        </Grid>
                      </Fragment>
                    );
                  })}
                </Grid>
              </Grid>
              {forLoop(item, tmparray, breite)}
            </Grid>
          </Grid>
        </Hidden>
        <Hidden mdUp>{forLoopMobil(item, tmparray, breite)}</Hidden>
      </Fragment>
    );
  }
  function renderFeld(item) {
    var italic = false;
    var bold = false;
    if (!item) return null;
    if (item.art === "S") {
      return (
        <Fragment>
          <Grid item xs={12} md={4}>
            <Typography align="left">{item.name}</Typography>
          </Grid>
          <Grid item xs={12} md={8} align="left">
            <TextField
              size="small"
              fullWidth
              disabled
              value={felder[formular][item.key] && felder[formular][item.key].antwort ? felder[formular][item.key].antwort : (hper[item.feld]?.inhalt ?? "")}
            />
          </Grid>
        </Fragment>
      );
    }
    if (item.art === "D") {
      return (
        <Fragment>
          <Grid item xs={12} md={4}>
            <Typography align="left">{item.name}</Typography>
          </Grid>
          <Grid item xs={12} md={8} align="left">
            <TextField
              size="small"
              fullWidth
              disabled
              value={
                felder[formular][item.key] && felder[formular][item.key].antwort
                  ? felder[formular][item.key].antwort
                  : dbliste[dbliste.findIndex((e) => e.key === item.inhalt)].felder[
                      dbliste[dbliste.findIndex((e) => e.key === item.inhalt)].felder.findIndex((e) => e.key === item.extra)
                    ].wert
              }
            />
          </Grid>
        </Fragment>
      );
    }
    if (item.art === "G") {
      const tmparray = item.inhalt.split(";");
      if (tmparray.filter((e) => e.startsWith("I") && felder[formular][e].typ === "08").length > 0) {
        return renderZeilenumbruchGruppe(tmparray, item);
      }

      if (!item.inhalt || tmparray.length === 0) return;
      var zeilen = pruefeAntworten(tmparray);
      var breite = 12 / tmparray.length;
      // const zwis = renderGruppe(tmparray, item);
      // return zwis;

      return renderGruppe(item);
    }
  }
  const renderZeilenumbruchGruppe = (array, item) => {
    const einzelArrays = splitArray(array);
    const tmparray = array;
    var italic = false;
    var bold = false;
    var breite = 12 / tmparray.length;
    return (
      <Fragment>
        <Hidden mdDown>
          <Grid item xs={12}>
            {forLoopZeilenUmbruch(item, tmparray, breite)}
          </Grid>
        </Hidden>
        <Hidden mdUp>{forLoopMobil(item, tmparray, breite)}</Hidden>
      </Fragment>
    );
  };
  function forLoop(item, tmparray, breite) {
    var array = [];
    for (var i = 1; i <= Number(item.logik); i++) {
      array.push(i);
    }
    var zeilen = pruefeAntworten(tmparray);
    return (
      <Fragment>
        {array.map((i) => {
          if (i > zeilen + 1) return <Fragment />;
          return (
            <Fragment>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  {Number(item.logik) > 1 && (
                    <Grid item xs={1}>
                      {Number(item.logik) > 1 && zeilen >= 1 && <Typography>{i.toString()}</Typography>}
                    </Grid>
                  )}
                  <Grid item xs={11}>
                    <Grid container spacing={2}>
                      {tmparray.map((id, index) => {
                        if (felder[formular][id].art === "R") {
                          grpfelder.current[id] = item.key;
                        }
                        if (felder[formular][id].art === "R" && felder[formular][id].typ === "07") {
                          return "";
                        }
                        return (
                          <Grid item xs={12} md={breite <= 2.4 ? true : breite} align="left">
                            {felder[formular][id].art === "I" && (
                              <FormularFeld
                                client={client}
                                accessToken={accessToken}
                                program={program}
                                ZSpeichern={ZSpeichern}
                                key={felder[formular][id]}
                                element={felder[formular][id]}
                                onChange={WertChange}
                                DateiLaden={DateiLaden}
                                files={files}
                                ChangeFiles={ChangeFiles}
                                ind={i}
                                felderError={felderError}
                                uebergaben={uebergaben}
                                lock={lock}
                              />
                            )}
                            {felder[formular][id].art === "E" && (
                              <FormularFeld
                                client={client}
                                accessToken={accessToken}
                                program={program}
                                ZSpeichern={ZSpeichern}
                                key={felder[formular][id]}
                                element={felder[formular][id]}
                                onChange={WertChange}
                                felderError={felderError}
                                DateiLaden={DateiLaden}
                                files={files}
                                ChangeFiles={ChangeFiles}
                                ind={i}
                                gruppe={item.key}
                                Summe={Summe}
                                uebergaben={uebergaben}
                                lock={lock}
                              />
                            )}
                            {felder[formular][id].art === "R" && (
                              <FormularFeld
                                client={client}
                                accessToken={accessToken}
                                program={program}
                                ZSpeichern={ZSpeichern}
                                key={felder[formular][id]}
                                element={felder[formular][id]}
                                onChange={WertChange}
                                DateiLaden={DateiLaden}
                                files={files}
                                felderError={felderError}
                                ChangeFiles={ChangeFiles}
                                ind={i}
                                gruppe={item.key}
                                Summe={Summe}
                                uebergaben={uebergaben}
                                lock={lock}
                              />
                            )}
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Fragment>
          );
        })}
      </Fragment>
    );
  }
  function forLoopMobil(item, tmparray, breite) {
    var bold = false;
    var italic = false;
    var array = [];
    for (var i = 1; i <= Number(item.logik); i++) {
      array.push(i);
    }
    var zeilen = pruefeAntworten(tmparray);
    return (
      <Fragment>
        {array.map((i) => {
          if (i > zeilen + 1) return <Fragment />;
          return (
            <Fragment>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  {tmparray.map((id, index) => {
                    italic = false;
                    bold = false;
                    if (felder[formular][id].art === "I" && felder[formular][id].typ === "08") {
                      return;
                    }
                    if (felder[formular][id].art === "R" && felder[formular][id].typ === "07") {
                      return;
                    }
                    if (felder[formular][id].format && (felder[formular][id].format === "03" || felder[formular][id].format === "04")) italic = true;
                    if (felder[formular][id].format && (felder[formular][id].format === "02" || felder[formular][id].format === "04")) bold = true;
                    if (felder[formular][id].art === "R") {
                      grpfelder.current[id] = item.key;
                    }
                    return (
                      <Fragment>
                        <Grid item xs={12}>
                          {felderError.findIndex((j) => j.includes(id)) !== -1 &&
                          felderError[felderError.findIndex((j) => j.includes(id))].substr(4, 1) >= i &&
                          (!felder[formular][id].antwort || !felder[formular][id].antwort[i] || felder[formular][id].antwort[i] === "") ? (
                            <Typography
                              style={
                                bold && italic
                                  ? { fontStyle: "italic", fontWeight: "bold", color: setColor2("255100100", 1) }
                                  : bold
                                    ? { fontWeight: "bold", color: setColor2("255100100", 1) }
                                    : italic
                                      ? { fontStyle: "italic", color: setColor2("255100100", 1) }
                                      : { color: setColor2("255100100", 1) }
                              }
                            >
                              {felder[formular][id].label === "1"
                                ? ""
                                : Number(item.logik) > 1 && zeilen >= 1
                                  ? felder[formular][id].name + "   ( " + i.toString() + " )"
                                  : felder[formular][id].name}
                            </Typography>
                          ) : (
                            <Typography
                              style={
                                bold && italic
                                  ? { fontStyle: "italic", fontWeight: "bold" }
                                  : bold
                                    ? { fontWeight: "bold" }
                                    : italic
                                      ? { fontStyle: "italic" }
                                      : {}
                              }
                            >
                              {felder[formular][id].label === "1"
                                ? ""
                                : Number(item.logik) > 1 && zeilen >= 1
                                  ? felder[formular][id].name + "   ( " + i.toString() + " )"
                                  : felder[formular][id].name}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={12}>
                          {felder[formular][id].art === "I" && (
                            <FormularFeld
                              client={client}
                              accessToken={accessToken}
                              program={program}
                              ZSpeichern={ZSpeichern}
                              felderError={felderError}
                              key={felder[formular][id]}
                              element={felder[formular][id]}
                              onChange={WertChange}
                              DateiLaden={DateiLaden}
                              files={files}
                              ChangeFiles={ChangeFiles}
                              ind={i}
                              uebergaben={uebergaben}
                              lock={lock}
                            />
                          )}
                          {felder[formular][id].art === "E" && (
                            <FormularFeld
                              client={client}
                              accessToken={accessToken}
                              program={program}
                              ZSpeichern={ZSpeichern}
                              key={felder[formular][id]}
                              element={felder[formular][id]}
                              onChange={WertChange}
                              DateiLaden={DateiLaden}
                              files={files}
                              ChangeFiles={ChangeFiles}
                              felderError={felderError}
                              ind={i}
                              gruppe={item.key}
                              uebergaben={uebergaben}
                              lock={lock}
                            />
                          )}
                          {felder[formular][id].art === "R" && (
                            <FormularFeld
                              client={client}
                              accessToken={accessToken}
                              program={program}
                              ZSpeichern={ZSpeichern}
                              key={felder[formular][id]}
                              element={felder[formular][id]}
                              onChange={WertChange}
                              DateiLaden={DateiLaden}
                              files={files}
                              felderError={felderError}
                              ChangeFiles={ChangeFiles}
                              ind={i}
                              gruppe={item.key}
                              uebergaben={uebergaben}
                              lock={lock}
                            />
                          )}
                        </Grid>
                      </Fragment>
                    );
                  })}
                </Grid>
              </Grid>
              <hr align="center" width="100%" height="2px" color="black" />
            </Fragment>
          );
        })}
      </Fragment>
    );
  }

  function forLoopZeilenUmbruch(item, tmparray, breiten) {
    var array = [];
    for (var i = 1; i <= Number(item.logik); i++) {
      array.push(i);
    }
    var einzelArrays = splitArray(tmparray);
    var zeilen = pruefeAntworten(tmparray);
    return (
      <Fragment>
        {array.map((i) => {
          if (i > zeilen + 1) return <Fragment />;
          return (
            <Fragment>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={1}>
                    {Number(item.logik) > 1 && zeilen >= 1 && <Typography>{i.toString()}</Typography>}
                  </Grid>
                  <Grid item xs={11}>
                    <Grid container spacing={2}>
                      {einzelArrays?.map((zwis) => {
                        var breite = 12 / zwis.length;
                        return zwis.map((id, index) => {
                          if (felder[formular][id].art === "R") {
                            grpfelder.current[id] = item.key;
                          }
                          if (felder[formular][id].art === "R" && felder[formular][id].typ === "07") {
                            return "";
                          }
                          return (
                            <Grid item xs={12} md={breite} align="left">
                              {felder[formular][id].art === "I" && (
                                <FormularFeld
                                  client={client}
                                  accessToken={accessToken}
                                  program={program}
                                  ZSpeichern={ZSpeichern}
                                  key={felder[formular][id]}
                                  element={felder[formular][id]}
                                  onChange={WertChange}
                                  DateiLaden={DateiLaden}
                                  files={files}
                                  ChangeFiles={ChangeFiles}
                                  ind={i}
                                  uebergaben={uebergaben}
                                  lock={lock}
                                />
                              )}
                              {felder[formular][id].art === "E" && (
                                <>
                                  {felderError.findIndex((j) => j.includes(id)) !== -1 &&
                                  felderError[felderError.findIndex((j) => j.includes(id))].substr(4, 1) >= i &&
                                  (!felder[formular][id].antwort || !felder[formular][id].antwort[i] || felder[formular][id].antwort[i] === "") ? (
                                    <Typography style={{ color: setColor2("255100100", 1) }}>{felder[formular][id].name}</Typography>
                                  ) : (
                                    <div>{felder[formular][id].name}</div>
                                  )}
                                  <FormularFeld
                                    client={client}
                                    accessToken={accessToken}
                                    program={program}
                                    ZSpeichern={ZSpeichern}
                                    key={felder[formular][id]}
                                    element={felder[formular][id]}
                                    onChange={WertChange}
                                    DateiLaden={DateiLaden}
                                    files={files}
                                    felderError={felderError}
                                    ChangeFiles={ChangeFiles}
                                    ind={i}
                                    gruppe={item.key}
                                    Summe={Summe}
                                    uebergaben={uebergaben}
                                    lock={lock}
                                  />
                                </>
                              )}
                              {felder[formular][id].art === "R" && (
                                <>
                                  <div>{felder[formular][id].name}</div>
                                  <FormularFeld
                                    client={client}
                                    accessToken={accessToken}
                                    program={program}
                                    ZSpeichern={ZSpeichern}
                                    key={felder[formular][id]}
                                    element={felder[formular][id]}
                                    onChange={WertChange}
                                    DateiLaden={DateiLaden}
                                    files={files}
                                    ChangeFiles={ChangeFiles}
                                    ind={i}
                                    gruppe={item.key}
                                    Summe={Summe}
                                    uebergaben={uebergaben}
                                    lock={lock}
                                  />
                                </>
                              )}
                            </Grid>
                          );
                        });
                      })}
                    </Grid>
                  </Grid>
                  <hr align="center" width="100%" height="2px" color="black" />
                </Grid>
              </Grid>
            </Fragment>
          );
        })}
      </Fragment>
    );
  }

  function renderFormular() {
    return (
      <Fragment>
        <Grid container justifyContent="center" spacing={2}>
          {bemerkung && bemerkung !== "" && (
            <Grid item xs={12}>
              <Card fullWidth>
                <Box p={1}>
                  <div disabled>
                    <TextField
                      id="comment"
                      label={t("Grund für das Zurücksenden")}
                      multiline
                      fullWidth
                      error={true}
                      //style={{borderColor:setColor2("255000000","1")}}
                      value={bemerkung}
                      //disabled

                      variant="outlined"
                    />
                  </div>
                </Box>
              </Card>
            </Grid>
          )}
          <Grid item xs={12}>
            <Card fullWidth>
              <Box p={1}>
                <Typography variant="h4" style={{ fontWeight: 700 }} align="center">
                  {title}
                </Typography>
              </Box>
            </Card>
          </Grid>
        </Grid>
        {liste
          .filter((key) => {
            if (felder[formular][key]) return true;
            if (stammfelder[key]) return true;
            return false;
          })
          .map((item, index) => {
            // console.log(item);
            return (
              <Grid item xs={12}>
                <Card>
                  <Box p={1}>
                    <Grid
                      container
                      justifyContent="flex-start"
                      spacing={2}
                      style={felderError.some((i) => i === item) ? { color: setColor2("255100100", 1) } : {}}
                    >
                      {item.substr(0, 1) === "S" ? (
                        renderFeld(stammfelder[item])
                      ) : item.substr(0, 1) === "G" ? (
                        renderFeld(felder[formular][item])
                      ) : item.substr(0, 1) === "D" ? (
                        renderFeld(felder[formular][item])
                      ) : item.substr(0, 1) === "P" ? (
                        renderPFeld(felder[formular][item])
                      ) : item.substr(0, 1) === "V" ? (
                        renderVFeld(felder[formular][item])
                      ) : (
                        <FormularFeld
                          client={client}
                          accessToken={accessToken}
                          program={program}
                          ZSpeichern={ZSpeichern}
                          key={felder[formular][item]}
                          element={felder[formular][item]}
                          onChange={WertChange}
                          files={files}
                          ChangeFiles={ChangeFiles}
                          DateiLaden={DateiLaden}
                          felderError={felderError}
                          ind={-1}
                          Summe={Summe}
                          uebergaben={uebergaben}
                          lock={lock}
                        />
                      )}
                    </Grid>
                  </Box>
                </Card>
              </Grid>
            );
          })}
      </Fragment>
    );
  }

  //Rückgabe
  return (
    <Box p={1}>
      <Grid container justifyContent="center" spacing={2}>
        <Grid item xs={12}>
          <Grid container justifyContent="center">
            {renderFormular()}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Formular;
